function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

export function editSiderMenus(routeConfig) {
  function it(routeConfigs) {
    var res = routeConfigs.filter(function (v) {
      if (v.redirect) {
        return false;
      }

      return v.opt.sider;
    }).map(function (v) {
      var _children;

      var page = v;
      var path = page.path;
      var title = page.opt.title;
      var children = it((_children = page.children) !== null && _children !== void 0 ? _children : []);
      return {
        key: path,
        title: title,
        children: children.length ? children : undefined
      };
    });
    return res;
  }

  return it(routeConfig);
}
/** ts 辅助函数 */

export function checkRedirect(v) {
  if (v.redirect) {
    return true;
  }

  return false;
}
export function itMap(v) {
  return v.map(function (v) {
    var _v$children;

    var children = itMap((_v$children = v.children) !== null && _v$children !== void 0 ? _v$children : []);
    return _objectSpread(_objectSpread({}, v), {}, {
      children: children.length ? children : undefined
    });
  });
}
export function itFilter(items, cb) {
  return itMap(items).filter(function (v) {
    if (v.children) {
      v.children = itFilter(v.children, cb);
    }

    return cb(v);
  });
}
export function flatten(items, cb) {
  var res = [];

  function it(items) {
    items.forEach(function (v) {
      res.push(cb(v));

      if (v.children) {
        it(v.children);
      }
    });
  }

  it(items);
  return res;
}
//# sourceMappingURL=es/editSiderMenus.js.map